export default __webpack_public_path__ + "static/media/pethelp_desktop.f38251da.webp";